import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { rfiSourceVersionsClient } from '../../lib/connect/clients';
export function useRfiSourceVersions(rfiResponseProjectId) {
    return useQuery({
        queryKey: [
            'rfi-source-versions',
            rfiResponseProjectId
        ],
        queryFn: async ()=>(await rfiSourceVersionsClient.listRfiSourceVersions({
                rfiResponseProjectId
            })).versions,
        retry: false
    });
}
export function useRfiSourceVersionMutations(rfiResponseProjectId) {
    const cache = useQueryClient();
    const onSuccess = async ()=>{
        await cache.invalidateQueries({
            queryKey: [
                'rfi-source-versions',
                rfiResponseProjectId
            ]
        });
        await cache.invalidateQueries({
            queryKey: [
                'capture-solution-reviews'
            ]
        });
    };
    const record = useMutation({
        mutationFn: (artifactId)=>rfiSourceVersionsClient.recordRfiSourceVersion({
                rfiResponseProjectId,
                artifactId
            }),
        onSuccess
    });
    const review = useMutation({
        mutationFn: (args)=>rfiSourceVersionsClient.reviewRfiSourceVersion({
                rfiResponseProjectId,
                ...args
            }),
        onSuccess
    });
    return {
        record,
        review
    };
}
